import { render, staticRenderFns } from "./staff-select.vue?vue&type=template&id=ed2db73c&"
import script from "./staff-select.vue?vue&type=script&lang=js&"
export * from "./staff-select.vue?vue&type=script&lang=js&"
import style0 from "./staff-select.vue?vue&type=style&index=0&id=ed2db73c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports